import {FINISH_LOADING_APPLICATION, LOAD_MACHINES_FROM_CACHE, RLTD_ACC_NOT_AVL} from "../action";
import { getAllMachines } from "../api/api";

export function loadMachinesFromCache() {
  return (dispatch) => {
    return getAllMachines()
      .then((data) => {
        if (data && data.length > 0) {
          dispatch({ type: LOAD_MACHINES_FROM_CACHE, payload: data });
        } else {
          dispatch({ type: LOAD_MACHINES_FROM_CACHE, payload: [] });
          dispatch({ type: RLTD_ACC_NOT_AVL });
            dispatch({ type: FINISH_LOADING_APPLICATION });
          console.warn("No machines found in cache.");
        }
      })
      .catch((error) => {
        dispatch({ type: LOAD_MACHINES_FROM_CACHE, payload: [] });
        console.error("Error loading machines from cache:", error);
        dispatch({type: RLTD_ACC_NOT_AVL});
        dispatch({ type: FINISH_LOADING_APPLICATION });
      });
  };
}
